export enum PeriodType {
Item1,
Item3,
Item4,
Item5,
Item11,
Item12,
Item13,
Item14,
Item15,
Item16,
}
